module.exports = {"title":"Abnormal Hole List","headerGolfClub":"Golf Club","headerPinId":"Pin ID","headerReport":"Report","headerBattery":"Battery","headerAlarm":"Alert","statusNormal":"Normal","chargeRequired":"Charge Required","smsHeader":"[APL Alert]","smsErrorOccurred":"Voice Caddie APL service error occurred.","smsHoleItem":"{course} Course, Hole {hole}, No.{id}","smsFooter":"Please inspect the device.","sendSms":"Send SMS","call":"Call","noContact":"No contact number for the manager.","smsSent":"SMS has been sent."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/ma101.json
// module id = 0FPF
// module chunks = 2